// extracted by mini-css-extract-plugin
export var actionButton = "_xr-2";
export var card = "_xr-0";
export var errorCard = "_xr-3";
export var row = "_xr-1";